import * as React from "react";

type RiyalIconProps = {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
  color?: string;
};

const RiyalIcon = ({
  width = 17,
  height = 17,
  className,
  style,
  color = "#D1D3D4",
}: RiyalIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <path
      d="M14.8 14.6594L10.6642 15.5618M10.6642 3.00394V11.441C10.6642 11.5552 10.6903 11.668 10.7404 11.7706C10.7905 11.8733 10.8633 11.9631 10.9533 12.0335C11.0433 12.1038 11.1482 12.1526 11.2599 12.1764C11.3716 12.2001 11.4873 12.1981 11.5981 12.1704L14.8 11.426M2 14.5474L6.17267 13.5225C6.49825 13.4337 6.7845 13.238 6.98541 12.9668C7.18631 12.6957 7.29018 12.3649 7.28032 12.0276V1.5M14.8 7.51574L2.76851 10.1476"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RiyalIcon;